import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { AppMenuItem, LoginSettings } from "medere-ui-framework";
import { defaultHomeViewDataDTO, HomeViewDataDTO } from "../../dto/HomeViewDataDTO";
import { loadHomeViewDataForUser } from "../../servicesHooks/ProfileDataForm/useProfileDataFormService";
import { useDispatch } from "react-redux";
import './HomeView.scss';


export default function HomeView() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Snapshot de settings al montar (igual que Dashboard): en un logout, localStorage se limpia
    // antes de que se complete la redirección a /login, y un re-render no debe romper la vista.
    const [appConfig] = useState<LoginSettings>(() => JSON.parse(localStorage.getItem("settings") ?? "{}"));
    const menuItems: AppMenuItem[] = appConfig.loginResponse?.appMenuConfiguration?.menuItems ?? [];

    const [homeViewData, setHomeViewData] = useState<HomeViewDataDTO>(defaultHomeViewDataDTO);
    useEffect(() => {
        loadHomeViewDataForUser().then((data) => {
            setHomeViewData(data);
        });
    }, []);

    function hasMenuItem(menuItems: AppMenuItem[], menuItem: number): boolean {
        for (let i = 0; i < menuItems.length; i++) {
            if (menuItems[i].menuItem === menuItem) {
                return true;
            }
            if (menuItems[i].items && hasMenuItem(menuItems[i].items, menuItem)) {
                return true;
            }
        }
        return false;
    }

    const allowedViews = {
        urgenciesView: hasMenuItem(menuItems, 25),
        hospitalizationView: hasMenuItem(menuItems, 21),
        patientsView: hasMenuItem(menuItems, 23),
        surgeryView: hasMenuItem(menuItems, 2035),
        appointmentsView: hasMenuItem(menuItems, 305),
        interconsultationsView: hasMenuItem(menuItems, 24),
        recipesView: hasMenuItem(menuItems, 1045),
    };

    function NavigationButtons() {
        const buttons = [
            { visible: allowedViews.urgenciesView, label: "Guardia", path: "/dashboard/urgencyattentionview", icon: "/imgs/guardia.png" },
            { visible: allowedViews.hospitalizationView, label: "Internación", path: "/dashboard/CRUDNewHospitalizationsView", icon: "/imgs/internacion.png" },
            { visible: allowedViews.patientsView, label: "Pacientes", path: "/dashboard/crudpatientrecordview", icon: "/imgs/pacientes.png" },
            { visible: allowedViews.surgeryView, label: "Quirófano", path: "/dashboard/surgeryscheduledappointmentsview", icon: "/imgs/quirofano.png" },
            { visible: allowedViews.appointmentsView, label: "Turnos del día", path: "/dashboard/CRUDAppointmentsQueueView", icon: "/imgs/turnos.png" },
        ];
    
        return (
            <div className="flex flex-wrap justify-content-start gap-4 mt-5">
                {buttons.map((b, i) =>
                    b.visible ? (
                    <button
                        key={i}
                            onClick={() => navigate(b.path)}
                        className="flex flex-column align-items-start iconButtonCards home-navigation-button"
                    >
                        <div>
                            <img src={b.icon} alt={b.label} className="text-teal-600 w-2,5 h-10"/>
                        </div>
                        <span className="font-semibold text-left" style={{
                            fontSize: "15px",
                            lineHeight: "28px",
                            letterSpacing: "0%",
                            verticalAlign: "middle",
                            color: "#305280",
                            marginTop: "5px",
                        }}>{b.label}</span>
                    </button>
                    ) : null
                )}
            </div>
        );
    }
    

    function InnitCards() {

        return (
            <div className="home-pendings-grid">
                {allowedViews.interconsultationsView && 
                <div className="pendingsCard p-4 flex flex-column align-items-center">
                    <h2 className="font-semibold text-lg mb-2" style={{ color: '#305280' }}>INTERCONSULTAS</h2>
                    {homeViewData.pendingInterconsultations === 0 ? (
                        <p className="text-sm mb-4">No existen pedidos pendientes</p>
                    ) : (
                        <p className="text-sm mb-4">Existen {homeViewData.pendingInterconsultations} pedidos pendientes</p>
                    )}
                    <button
                        onClick={() => navigate("/dashboard/medicalqueryview")}
                        className="home-pending-action font-semibold"
                    >
                        
                        Consultar
                    </button>
                </div>}
                {allowedViews.recipesView && 
                <div className="pendingsCard p-4 flex flex-column align-items-center">
                    <h2 className="font-semibold text-lg mb-2" style={{ color: '#305280' }}>RECETAS</h2>
                    {homeViewData.pendingRP === 0 ? (
                        <p className="text-sm mb-4">No existen pedidos pendientes</p>
                    ) : (
                        <p className="text-sm mb-4">Existen <span className="text-orange-600 font-medium" >{homeViewData.pendingRP} pedidos pendientes</span></p>
                    )}
                    <button
                        onClick={() => navigate("/dashboard/RecipeView?activeViewID=2")}
                        className="home-pending-action font-semibold"
                    >
                        Recetar
                    </button>
                </div>}
            </div>
        );
    }

    return (
        <div className="px-6 py-4 homeViewContainer">
            <div>
                <h1 style={{ fontWeight: 600, color: "#B67345", marginBottom: "5px", fontSize: "20px" }}>
                    Hola, {appConfig.loginResponse?.user?.displayname ?? ""}
                </h1>
                {homeViewData.professional && <p style={{ fontSize: "15px", color: "#2D3748" }}>
                    {homeViewData.specialitieslist.join(", ")} | <strong> {homeViewData.workerenrollmenttype} {homeViewData.workenrollment} </strong>
                </p>}
            </div>
            <NavigationButtons />
            {homeViewData.professional && <InnitCards />}
        </div>
    );
}
